export default {
  getJobListingTask: (state) => state.jobListingTask,
};
